// SMS provider catalogue. Each provider declares the api_credential fields it
// needs (plus entity_id, which is stored in its own column). Shared by the
// grouped list (credential preview) and the add/edit drawer.
export const PROVIDERS = [
  { name: "orbital", fields: ["user_id", "password", "entity_id"], labels: ["User Id", "Password", "Entity Id"] },
  { name: "smslane", fields: ["api_key", "entity_id"], labels: ["Api Key", "Entity Id"] },
  { name: "juro", fields: ["token", "entity_id"], labels: ["Token", "Entity Id"] },
  { name: "pinnacle", fields: ["user_id", "password", "entity_id"], labels: ["User Id", "Password", "Entity Id"] },
  { name: "smartping", fields: ["user_id", "password", "entity_id"], labels: ["User Id", "Password", "Entity Id"] },
  { name: "smscountry", fields: ["user_id", "password", "entity_id"], labels: ["User Id", "Password", "Entity Id"] },
  { name: "termii", fields: ["api_key", "entity_id"], labels: ["Api Key", "Entity Id"] },
];

export const getProvider = (name) => PROVIDERS.find((p) => p.name === name);

// api_credential keys are every field except entity_id (which is a column).
export const credentialFields = (provider) =>
  provider ? provider.fields.filter((f) => f !== "entity_id") : [];

export const labelFor = (provider, field) => {
  if (!provider) return field;
  const idx = provider.fields.indexOf(field);
  return idx >= 0 ? provider.labels[idx] : field;
};

export const isSecretField = (field) =>
  /password|token|api_key|secret/i.test(String(field || ""));
